module.exports = __webpack_public_path__ + "img/co.27b71dc7.svg";